import Index from '../../views/main/landings/Index'
import Create from '../../views/main/landings/Create'
import Edit from '../../views/main/landings/Edit';

export default [
  {
    component: Index,
    name: 'landings-index',
    path: '/landings',
    meta: {
      layout: 'main-layout',
      requiresAuth: true,
      module: 'landings'
    }
  },
  {
    component: Create,
    name: 'landings-create',
    path: '/landings/create',
    meta: {
      layout: 'main-layout',
      requiresAuth: true,
      module: 'landings'
    }
  },
  {
    component: Edit,
    name: 'landings-edit',
    path: '/landings/edit/:id',
    meta: {
      layout: 'main-layout',
      requiresAuth: true,
      module: 'landings'
    }
  },
]
